import React, { useState } from 'react';
import { designSystem } from '@yola/ws-ui';
import PropTypes from 'prop-types';
import DifmBannerModal from '../components/difm-banner-modal';
import DifmBannerSelectItem from '../components/difm-banner-select-item';
import options from '../constants/services-options';

const { Stack, ControlGroup } = designSystem;

const modalCaptions = {
  title: 'DIFM services',
  back: 'Back',
  next: 'Continue',
  subTitle: 'Please select the service',
};

const DifmBannerServicesContainer = ({ values, onBack = null, onClose, onNext, onSelect }) => {
  const [serviceName, setServiceName] = useState(values.serviceName);

  const onSelectItemClick = (value) => {
    setServiceName(value);
    onSelect(value);
  };

  const handleBack = () => onBack && onBack({ ...values, serviceName });
  const handleNext = () => onNext({ ...values, serviceName });

  return (
    <DifmBannerModal
      onNext={handleNext}
      isNextDisabled={!serviceName}
      onClose={onClose}
      captions={modalCaptions}
      {...(onBack && { onBack: handleBack })}
    >
      <ControlGroup title={modalCaptions.subTitle} required>
        <Stack gap="spacing-2-xs">
          {options.map(({ value, ...restProps }) => (
            <DifmBannerSelectItem
              key={value}
              active={value === serviceName}
              value={value}
              onClick={onSelectItemClick}
              {...restProps}
            />
          ))}
        </Stack>
      </ControlGroup>
    </DifmBannerModal>
  );
};

DifmBannerServicesContainer.propTypes = {
  values: PropTypes.shape({
    serviceName: PropTypes.string,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  onBack: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf([null])]),
  onNext: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default DifmBannerServicesContainer;
